export async function get(endpoint) {
    const raw = await fetch(`/api/${endpoint}`, {
        method: 'GET'
    });
    return await raw.json();
}
export async function post(endpoint, body = {}) {
    const raw = await fetch(`/api/${endpoint}`, {
        method: 'POST',
        body: JSON.stringify(body)
    });
    return await raw.json();
}
